import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=052689b2&scoped=true&"
import script from "./Tours.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tours.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Tours.vue?vue&type=style&index=0&id=052689b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052689b2",
  null
  
)

export default component.exports